module.exports = __webpack_public_path__ + "media/images/logo-lavu-0b65852413ddc6e4809671d4310bd5d6.svg";